import { render, staticRenderFns } from "./AppVersionBadge.vue?vue&type=template&id=5de2f2db&scoped=true"
import script from "./AppVersionBadge.vue?vue&type=script&lang=js"
export * from "./AppVersionBadge.vue?vue&type=script&lang=js"
import style0 from "./AppVersionBadge.vue?vue&type=style&index=0&id=5de2f2db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de2f2db",
  null
  
)

export default component.exports